const owners = new Set<object>();

/** Bloque le scroll du body tant qu'au moins un overlay (dialog, drawer, palette…) le demande. */
export function lockBodyScroll(owner: object): void {
  owners.add(owner);
  syncBodyScroll();
}

export function unlockBodyScroll(owner: object): void {
  owners.delete(owner);
  syncBodyScroll();
}

function syncBodyScroll(): void {
  document.body.style.overflow = owners.size ? "hidden" : "";
}
